export default {
	name: 'TaskCategoryLookup',
	options: {
		tablename: 'v_task_statuses_per_category',
		schema: 'cabsav',
		sortfield: 'task_category'
	}
};

